<template>
  <div>
    <h2 class="text-primary-dark seccion d-flex">Dar parte de siniestro</h2>
    <div class="row stepper mb-3">
      <div class="col stepper-stage clickable" :class="{ 'active' : stage == 1 }" @click="changeStage(1)">
        <div class="stepper-stage-icon" :class="{ 'bg-primary' : stage == 1, 'bg-gris' : stage != 1 }"><font-awesome-icon icon="list"/></div>
        <div class="stepper-stage-text d-none d-md-block">Selección de póliza</div>
      </div>
      <div class="col stepper-stage clickable" :class="{ 'active' : stage == 2 }"  @click="changeStage(2)">
        <div class="stepper-stage-icon" :class="{ 'bg-primary' : stage == 2, 'bg-gris' : stage != 2 }"><font-awesome-icon icon="pencil-alt"/></div>
        <div class="stepper-stage-text d-none d-md-block">Descripción del siniestro</div>
      </div>
      <div class="col stepper-stage clickable" :class="{ 'active' : stage == 3 }" @click="changeStage(3)">
        <div class="stepper-stage-icon" :class="{ 'bg-primary' : stage == 3, 'bg-gris' : stage != 3 }"><font-awesome-icon icon="paperclip"/></div>
        <div class="stepper-stage-text d-none d-md-block">Adjuntar documentos</div>
      </div>
    </div>

    <div v-if="stage == 1">
      <h3 v-if="!$route.params.poliza" class="text-center text-primary-dark mb-0 pb-2 mb-2">Seleccione la póliza del siniestro</h3>
      <ListaPolizas :polizas="polizas" :loading="loading" :selected="poliza" @poliza-seleccionada="selectPoliza($event)"/>
      <!-- modal riesgos -->
      <modal v-if="showModalRiesgos" @close="showModalRiesgos = false">
        <h5 slot="header" class="text-light bg-primary mb-0 p-2">Riesgo</h5>
        <div slot="body">
          <p><strong>Seleccione el riesgo del siniestro</strong></p>
          <ul class="list-group">
            <li v-for="riesgo in poliza.riesgos" :key="riesgo.riesgo.id" @click="selectRiesgo(riesgo.riesgo)" class="list-group-item clickable">{{riesgo.riesgo.descripcion}}</li>
          </ul>
        </div>
        <div slot="footer" class="text-right">
          <button class="btn btn-danger" @click="showModalRiesgos = false">Cancelar</button>
        </div>
      </modal>
    </div>
    <!-- FIN STAGE 1 -->
    
    <div v-if="stage == 2">
      <h3 class="text-center text-primary-dark mb-0 pb-4">Describa las circunstancias, daños y aporte los datos relevantes</h3>
      <p><strong>Riesgo:</strong> {{ riesgo.descripcion }}</p>
      <form @submit.prevent="saveSiniestro()">
      <div class="form-group">
        <input-date v-model="fechaOcurrencia" class="form-control"/>
      </div>
      <div class="form-group">
        <textarea v-model="descripcion" rows="5" class="w-100 form-control"></textarea>
      </div>
      <div class="text-right">
        <button class="btn btn-primary disabled" v-if="sending" disabled>
          <font-awesome-icon icon="spinner" class="fa-spin"/> Creando siniestro
        </button>
        <button class="btn btn-primary" v-else>
          Dar parte
        </button>
      </div>
      </form>
    </div>
    <!-- FIN STAGE 2 -->

    <div v-if="stage == 3">
      <h3 class="text-primary-dark text-center mb-0 pb-4">Siniestro {{ siniestro.alias }}. ¿Quiere adjuntar documentación?</h3>
      <documentos-item :idObjeto="siniestro.id" tipoObjeto="13"/>
      <div class="text-center">
        <router-link :to="{ name: 'siniestro', params: {id: siniestro.id} }" class="btn btn-primary">Ir a ficha de siniestro</router-link>
      </div>
    </div>
    
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import util from '@/util'
import ListaPolizas from '@/components/widgets/polizas/ListaPolizas'
import DocumentosItem from '@/components/comunes/DocumentosItem'
import Modal from '@/components/widgets/Modal'
import InputDate from '@/components/widgets/InputDate'
export default {
  data() {
    return {
      loading: false,
      stage: 1,
      showModalRiesgos: false,
      poliza: null,
      riesgo: null,
      descripcion: '',
      fechaOcurrencia: new Date(),
      siniestro: null,
      sending: false,
      polizas: []
    }
  },
  computed: {
    ...mapGetters({
      urlBase: 'urlBase',
      credentials: 'credentials',
      //polizas: 'polizas',
      estados: 'estados'
    })
  },
  mounted() {
    this.loadPolizas();
  },
  methods: {
    saveSiniestro() {
      this.sending = true;
      let datos = {
        poliza: this.poliza.id,
        riesgo: this.riesgo.id,
        fechaSiniestro: this.fixDatesZero(this.fechaOcurrencia),
        fechaParte: this.fixDatesZero(new Date()),
        descripcion: this.descripcion
      }
      let url = this.urlBase + 'siniestros';
      this.$http.post(url, datos).then(
        (response) => {
          this.siniestro = response.body
          this.stage = 3
          this.sending = false
        },
        (error) => {
          console.log(error)
          this.sending = false
          alert("Error")
        }
      ); 
    },
    changeStage(stage) {
      if (this.stage > stage) {
        this.stage = stage;
      }
    },

    selectPoliza(poliza) {
      this.poliza = poliza;
      if (this.poliza.riesgos.length == 1) {
        this.stage = 2;
        this.riesgo = this.poliza.riesgos[0].riesgo;
      } else {
        this.showModalRiesgos = true;
      }
    },

    selectRiesgo(riesgo) {
      this.riesgo = riesgo
      this.showModalRiesgos = false;
      this.stage = 2;
    },
    
    loadPolizas() {

      // Si viene por parametro, solo cogemos una poliza
      if (this.$route.params.poliza) {
        this.getPoliza(this.$route.params.poliza)
        return
      }

      this.loading = true;
      let estados = [
        this.estados.polizaVigor
      ]
      let grupos = [
        'poliza.cliente',
        'poliza.producto',
        'poliza.riesgos',
        'poliza.compania',
        'producto.ramo',
        'poliza.recibo',
        'riesgoPoliza.riesgo'
      ]
      let params = {
        'grupos': grupos.join(','),
        'estados': estados.join(","),
        'page': 1,
        'limit': 50
      };

      let url = this.urlBase + 'polizas?' + util.objToQuery(params);
      this.$http.get(url).then(
        (response) => {
          this.polizas = response.body.items
          for(let i = 2; i <= response.body.totalPages; i++){
            params.page = i;
            let url = this.urlBase + 'polizas?' + util.objToQuery(params);
            this.$http.get(url).then(
              (response) => {
                response.body.items.forEach(function(poliza){
                  this.polizas.push(poliza)
                });
              },
              (error) => {
                alert("Error cargando pólizas")
              }
            );
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
        }
      );
    },
    getPoliza(id) {
      this.loading = true;
      let grupos = [
        'poliza.cliente',
        'poliza.producto',
        'poliza.riesgos',
        'poliza.compania',
        'producto.ramo',
        'poliza.recibo',
        'riesgoPoliza.riesgo'
      ]
      let params = {
        'grupos': grupos.join(',')
      };

      let url = this.urlBase + 'polizas/' + id + '?' + util.objToQuery(params);
      this.$http.get(url).then(
        (response) => {
          this.polizas = [response.body]
          this.selectPoliza(response.body)
          this.loading = false
        },
        (error) => {
          this.loading = false
          alert(error.body.error.message)
        }
      );
    },
    fixDatesZero(date) {
      return date.getFullYear()+'-'+
      ("0" + (date.getMonth()+1)).slice(-2)+'-'+
      ("0" + date.getDate()).slice(-2)
    }
  },
  components: {
    Modal,
    ListaPolizas,
    DocumentosItem,
    InputDate
  }
}
</script>
